












import _ from 'lodash'
import { Component } from 'vue-property-decorator'
import { Getter, Action } from 'vuex-class'
import VueExtendedBaseComponent from '@/VueExtendedBaseComponent.vue'
import { ELevel } from '@/services/Menus'
import { UserProfile } from '@/store/modules/views/userProfile/states'
import { IPatient } from '@/store/modules/views/patient/states'
import { ITimeline } from '@/store/modules/views/schedule/states'

@Component
export default class Log extends VueExtendedBaseComponent {
  private header = 'ประวัติการรักษา'

  @Getter('schedule/logPatientLists')
  private logPatientLists: ITimeline & IPatient

  @Getter('userprofile/getProfile')
  private profile!: UserProfile

  @Action('components/updateTitlePage')
  private updateTitlePage!: (title: string) => void

  @Action('schedule/getSchedulePatientLogList')
  private getSchedulePatientLogList!: (options: {}) => void

  private async created() {
    this.updateTitlePage(this.header)
    if (this.profile.role.name !== 'ผู้ดูแลระบบ') {
      this.$store.dispatch('components/setLevel', {id: this.profile._id, mode: ELevel.USER})
      // this.$router.push(`/action/profile`)
    }
    await this.getSchedulePatientLogList({
      id: this.$route.params.status,
    })
  }
}
